import { render, staticRenderFns } from "./SalesforceConnectPopup.vue?vue&type=template&id=47b70cd8&scoped=true"
import script from "./SalesforceConnectPopup.vue?vue&type=script&lang=js"
export * from "./SalesforceConnectPopup.vue?vue&type=script&lang=js"
import style0 from "./SalesforceConnectPopup.vue?vue&type=style&index=0&id=47b70cd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b70cd8",
  null
  
)

export default component.exports